import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card11.scss';

class Card11 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Raio X do Investidor Brasileiro: tem mais gente economizando - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card11-home page-gradient page-gradient--yellow bg-gray" ref="card11-home">
          <section className="iniciativas-area card11-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Raio X do Investidor Brasileiro: tem mais gente economizando</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-7">
                              <p>
                                Pelo terceiro ano consecutivo, divulgamos em 2020 nossa pesquisa sobre o perfil e o
                                comportamento do investidor brasileiro. Realizado em parceria com o Datafolha, o{' '}
                                <a
                                  href="https://www.anbima.com.br/pt_br/especial/raio-x-do-investidor-2020.htm"
                                  target="_blank"
                                >
                                  Raio X do Investidor Brasileiro
                                </a>{' '}
                                consultou 3.433 pessoas em 149 municípios em novembro de 2019, ou seja, não reflete os
                                impactos da pandemia de Covid-19, mostrados apenas na quarta edição, divulgada a partir
                                do primeiro trimestre de 2021.
                              </p>
                              <p>
                                De acordo com o levantamento que considerou as classes A, B ou C, 38% dos brasileiros
                                conseguiram economizar algum valor em 2019, cinco pontos percentuais a mais que no ano
                                anterior. Já o destino da economia permanece similar ao de anos anteriores: 42% desse
                                universo aplicou o dinheiro em produtos financeiros como renda fixa, títulos públicos,
                                poupança ou mercado de ações.
                              </p>
                            </div>
                            <div className="col-5 img-center h-img">
                              <img src={images.iniciativas.card11.img1} />
                            </div>
                          </div>

                          <div className="col-12">
                            <h3>Investidor digital x analógico</h3>
                            <p>
                              Pela primeira vez, o Raio X analisou se o investidor brasileiro é mais digital ou
                              analógico, concluindo que o perfil da maioria é tradicional: 71% vai até o banco para
                              fazer suas aplicações, enquanto 49% opta pelo site ou aplicativo do banco ou da corretora.
                              Esses chamados investidores analógicos têm em média 47 anos, 22% deles são aposentados,
                              65% pertencem à classe C e com renda familiar mensal em torno de R$ 4,4 mil. Já aqueles
                              que usam a internet para facilitar a vida financeira, os investidores digitais, são mais
                              jovens – têm, em média, 38 anos – 48% deles pertencem à classe B e registram renda média
                              mensal de R$ 7,4 mil.
                            </p>
                            <p>
                              Os dados completos da pesquisa que representa mais de 96 milhões de brasileiros
                              economicamente ativos (renda ou aposentadoria) estão disponíveis em uma{' '}
                              <a
                                href="https://www.anbima.com.br/pt_br/especial/raio-x-do-investidor-2020.htm"
                                target="_blank"
                              >
                                página especial
                              </a>{' '}
                              do nosso site. Confira!
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card11 };
